import { createPattern, escapeSelector } from '../../utils';
import { ClassObjectType } from '../../types';

// Pattern
export const pattern = createPattern(
        'flex-(nowrap|wrap|wrap-reverse)', 
        {breakpoints: true
    });

// Resolver
export const rules = (props): ClassObjectType => {
    const [className, breakpoint, value, reverse] = props;
    // console.log(props);
    const selector = escapeSelector(className);


    const rule = {
        [selector]: {
            flexWrap: value
        }
    };

    return {
        breakpoint,
        rule
    };
    
}

export default { pattern, rules };